"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    menuVariants: ()=>menuVariants
});
const tv_cjs_namespaceObject = require("../../../variants/tv.cjs");
const menuTransition = 'transition-all duration-[1.5s] ease-[linear(0,0.008_1.1%,0.031_2.2%,0.129_4.8%,0.257_7.2%,0.671_14.2%,0.789_16.5%,0.881_18.6%,0.957_20.7%,1.019_22.9%,1.063_25.1%,1.094_27.4%,1.114_30.7%,1.112_34.5%,1.018_49.9%,0.99_59.1%,1)] origin-center';
const menuVariants = (0, tv_cjs_namespaceObject.tv)({
    slots: {
        top: menuTransition,
        middle: menuTransition,
        bottom: menuTransition
    },
    defaultVariants: {
        isOpen: false
    },
    variants: {
        isOpen: {
            true: {
                top: 'transform-[rotate(225deg)_translateY(5px)]',
                middle: 'transform-[rotate(180deg)] opacity-0',
                bottom: 'transform-[rotate(135deg)_translateY(-5px)]'
            }
        }
    }
});
exports.menuVariants = __webpack_exports__.menuVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "menuVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
